import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { EndpointService, HttpErrorHandlingService } from "@app/core";

/**
 * Modelo de las dependencias
 *
 * @export
 * @interface Dependencie
 */
 export interface Dependencie {
  id: number;
  nombre: string;
  descripcion: string;
  codigo: number;
}

@Injectable()
export class ReassigmentDataService{
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService,
    private hehs: HttpErrorHandlingService,
  ) {}

 
  /**
   *Obtiene las dependencias del sistema
   *
   * @return {*}  {Observable<any>}
   * @memberof RadicationDocsDataService
   */
  getDependencies(validate_rols_and_dependence:boolean=false,task_id:any = null ): Observable<any> {
    let params = new HttpParams();
    if (validate_rols_and_dependence) {
      params = params.set('validate_rols_and_dependence', validate_rols_and_dependence.toString());
    }
    if (task_id !== null) {
      params = params.set('task', task_id.toString());
    }
    
    return new Observable((obs) => {
      this.http
        .get<any>(this.api.get("searchDependencie"), {
          observe: "response",
          params: params
        })
        .subscribe(
          (res) => {
            obs.next(res.body);
          },
          (err) => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error["message"], "Fallo en la consulta de datos de dependencias");
            }
            obs.error(err);
          }
        );
    });
  }

  /**
   *Consulta los funcionarios disponibles por dependencia
   *
   * @param {number} id
   * @return {*}  {Observable<any>}
   * @memberof RemissionDataService
   */
  getUsersDependencie(id: number,task_id: any = null): Observable<any> {
    let params = new HttpParams();
    if (task_id !== null) {
      params = params.set('task', task_id.toString());
    }
    return new Observable((obs) => {
      this.http
        .get<any>(this.api.get("search_users_dependencies", [id]), {
          observe: "response",
          params: params
        })
        .subscribe(
          (res) => {
            obs.next(res.body);
          },
          (err) => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error["message"], "Fallo en la consulta de usuarios por dependencias");
            }
            obs.error(err);
          }
        );
    });
  }

  /**
   *Crea o modificar los usuarios para remisión
   *
   * @param {number} task_id
   * @param {*} responsibles
   * @return {*} 
   * @memberof RemissionDataService
   */
  asignUsers(task_id: number, responsibles: any): Observable<any>{
    let formData = {
      tarea: task_id,
      responsables: responsibles
    }
    return new Observable((obs) => {
      this.http
        .post(this.api.get("responsible_document"), formData, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            if (res.status === 201 || res.status === 200) {
              obs.next(res.body);
              this.toastr.success("Usuarios asignados correctamente.", "Operación exitosa");
            } else {
              obs.next({});
            }
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });
  }

  /**
   *Obtiene los funcionarios asignados a la tarea
   *
   * @param {number} task_id
   * @return {*} 
   * @memberof RemissionDataService
   */
  getUserTask(task_id: number): Observable<any[]>{
    return new Observable((obs) => {
      this.http
        .get<any[]>(this.api.get("responsible_document", [task_id]), {
          observe: "response",
        })
        .subscribe(
          (res) => {
            obs.next(res.body);
          },
          (err) => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error["message"], "Fallo en modificar los funcionarios");
            }
            obs.error(err);
          }
        );
    });
  }

  /**
   *Realiza la reasignación de la tarea
   *
   * @param {number} task_id
   * @param {any[]} responsibles
   * @param {string} subject
   * @param {string} description
   * @return {*}  {Observable<any>}
   * @memberof ReassigmentDataService
   */
  reasignUsers(task_id: number, responsibles: any[], subject: string, description: string): Observable<any>{
    let formData = {
      id_tarea: task_id,
      responsables: responsibles,
      asunto: subject,
      descripcion: description
    }
    return new Observable((obs) => {
      this.http
        .post(this.api.get("reassignTask"), formData, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            if (res.status === 201 || res.status === 200) {
              obs.next(res.body);
              this.toastr.success("Usuarios asignados correctamente.", "Operación exitosa");
            } else {
              obs.next({});
            }
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reassigment-responsibles/shared/reassigment.data.service.ts